// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-button[data-v-3079cbbd] {\n  display: flex;\n  justify-content: flex-end;\n  align-items: flex-end;\n  margin-bottom: 2rem;\n}\n.header-button[data-v-3079cbbd]  .el-col {\n  width: auto;\n  margin-left: 2rem;\n}\n.header-button[data-v-3079cbbd]  .el-col .el-button {\n  font-size: inherit;\n  width: 20rem;\n}\n.dummy[data-v-3079cbbd] {\n  display: none;\n}\nth.billing-ym[data-v-3079cbbd] {\n  display: none;\n}\ntd.billing-ym[data-v-3079cbbd] {\n  display: none;\n}", ""]);
// Exports
module.exports = exports;
